/**
 * The source of the search request.
 *
 * @public
 */
export var QuerySource;
(function (QuerySource) {
    /**
     * Indicates that the query was initiated from a standard Answers integration.
     */
    QuerySource["Standard"] = "STANDARD";
    /**
     * Indicates that the query was initiated from an Answers Overlay.
     */
    QuerySource["Overlay"] = "OVERLAY";
    /**
     * Indicates that the query was initiated from visual autocomplete.
     */
    QuerySource["Autocomplete"] = "AUTOCOMPLETE";
})(QuerySource || (QuerySource = {}));
//# sourceMappingURL=QuerySource.js.map